import { sendPostRequest } from 'services';

export const uploadMedia = (file: any) =>
  sendPostRequest('/media/uploadGeneral', file, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
